module.exports = __webpack_public_path__ + "img/asli-narin-untitled.95b6abc.jpg";